import { render, staticRenderFns } from "./ResultPopup.vue?vue&type=template&id=7c6ef097&scoped=true"
import script from "./ResultPopup.vue?vue&type=script&lang=js"
export * from "./ResultPopup.vue?vue&type=script&lang=js"
import style0 from "./ResultPopup.vue?vue&type=style&index=0&id=7c6ef097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6ef097",
  null
  
)

export default component.exports